var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFileArrowDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21C21 21.434 20.8275 21.8502 20.5207 22.1571C20.2139 22.4639 19.7976 22.6364 19.3636 22.6364H4.63636C4.20237 22.6364 3.78616 22.4639 3.47927 22.1571C3.17241 21.8502 3 21.434 3 21V3C3 2.566 3.17241 2.14979 3.47927 1.84291C3.78616 1.53603 4.20237 1.36363 4.63636 1.36363H15.2727L21 7.0909V21Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2725 13.6366L11.9998 16.9094L8.72705 13.6366",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.9093V7.90935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFileArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fileArrowDown.88fa2c61.svg";
export { ForwardRef as ReactComponent };